const ITEMS = [
  "Nutrizione",
  "Movimento",
  "Scienza",
  "Personalizzazione",
  "Bologna",
];

const Row = ({ hidden }) => (
  <div
    aria-hidden={hidden}
    className="flex shrink-0 items-center"
  >
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-display italic text-2xl sm:text-3xl text-ink/70 px-8 sm:px-12 whitespace-nowrap">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-leaf" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      aria-label="I valori di Nutrimove Lab"
      className="overflow-hidden border-y border-ink/10 bg-paper py-6 select-none"
    >
      <div className="flex w-max animate-marquee">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </section>
  );
}
